import * as Actions from '../../actions';

const initialState = { data: null };

const listLabProviderReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_LAB_PROVIDER_LIST_DETAILS:
            return { ...state, data: { ...action.payload } };
        case Actions.GET_PROCESSOR_RECEIVER_LIST_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default listLabProviderReducer;
